import { ModelChangeUtils } from './../../../framework/edata/model-change-utils';
import { Injectable } from '@angular/core';
import { Command } from 'flux-core';
import { EDataChangeService } from '../edata-change.svc';
import { AbstractEDataChangeCommand } from './abstract-edata-change-command.cmd';

/**
 * runs all fomulas in the entity and updates data items bound to them.
 */
@Injectable()
@Command()
export class ApplyFormulas extends AbstractEDataChangeCommand {

    /**
     * Input data format for the command
     */
    public data:  {
        entityId: string,
    };

    constructor(
        protected es: EDataChangeService,
        protected modelChangeUtils: ModelChangeUtils,
    ) {
        super( es ) /* istanbul ignore next */;
    }

    public prepareData() {
        this.modelChangeUtils.applyFormulas(
            this.changeModel,
            this.data,
        );
    }
}

Object.defineProperty( ApplyFormulas, 'name', {
    value: 'ApplyFormulas',
});

